module.exports = __webpack_public_path__ + "static/img/wbrtc-bg.39e0f10.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/wbrtc-bg.png
// module id = d5yn
// module chunks = 1